import React from 'react';

const Logo = ({ className, size = 'md', withText = true, textColor = 'text-gray-800' }) => {
  // Size variants
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-10 w-10', 
    lg: 'h-14 w-14',
    xl: 'h-20 w-20'
  };
  
  // Text size variants based on logo size
  const textSizeClasses = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-3xl',
    xl: 'text-4xl'
  };
  
  return (
    <div className={`flex items-center ${className}`}>
      <div className="relative group">
        {/* Glow effect for hover */}
        <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-500 to-teal-400 blur-md opacity-0 group-hover:opacity-70 transition-opacity duration-500 scale-110"></div>
        
        {/* SVG Logo */}
        <svg 
          className={`${sizeClasses[size]} relative z-10 transition-transform duration-500 ease-out group-hover:rotate-12`}
          viewBox="0 0 100 100" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Main outer circle/shield */}
          <circle cx="50" cy="50" r="45" fill="url(#gradient-circle)" />
          
          {/* Secure network overlay */}
          <path 
            d="M50 13L82 29.5V55C82 67.6 69.8 79.2 50 87C30.2 79.2 18 67.6 18 55V29.5L50 13Z" 
            fill="url(#gradient-shield)" 
            fillOpacity="0.9"
          />
          
          {/* Interconnected nodes */}
          <circle cx="35" cy="40" r="5" fill="#FFFFFF" fillOpacity="0.9" />
          <circle cx="65" cy="40" r="5" fill="#FFFFFF" fillOpacity="0.9" />
          <circle cx="50" cy="65" r="5" fill="#FFFFFF" fillOpacity="0.9" />
          <circle cx="35" cy="65" r="3" fill="#FFFFFF" fillOpacity="0.7" />
          <circle cx="65" cy="65" r="3" fill="#FFFFFF" fillOpacity="0.7" />
          <circle cx="50" cy="30" r="3" fill="#FFFFFF" fillOpacity="0.7" />
          
          {/* Connection lines */}
          <path d="M35 40L50 30M65 40L50 30M35 40L35 65M65 40L65 65M35 40L50 65M65 40L50 65M35 65L50 65M65 65L50 65" 
                stroke="#FFFFFF" strokeWidth="1.5" strokeOpacity="0.6" />
          
          {/* Pulse animation */}
          <circle cx="50" cy="50" r="40" stroke="url(#gradient-pulse)" strokeWidth="2" strokeOpacity="0.5" fill="none">
            <animate attributeName="r" values="30;45" dur="3s" repeatCount="indefinite" />
            <animate attributeName="stroke-opacity" values="0.6;0.2" dur="3s" repeatCount="indefinite" />
          </circle>
          
          {/* Radial gradients */}
          <defs>
            <linearGradient id="gradient-circle" x1="10" y1="10" x2="90" y2="90" gradientUnits="userSpaceOnUse">
              <stop stopColor="#0B0F18" />
              <stop offset="1" stopColor="#1B2536" />
            </linearGradient>
            <linearGradient id="gradient-shield" x1="18" y1="13" x2="82" y2="87" gradientUnits="userSpaceOnUse">
              <stop stopColor="#3B82F6" />
              <stop offset="0.5" stopColor="#2563EB" />
              <stop offset="1" stopColor="#0EA5E9" />
            </linearGradient>
            <linearGradient id="gradient-pulse" x1="10" y1="10" x2="90" y2="90" gradientUnits="userSpaceOnUse">
              <stop stopColor="#3B82F6" />
              <stop offset="1" stopColor="#0EA5E9" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      
      {withText && (
        <div className={`ml-3 font-bold tracking-tight ${textSizeClasses[size]} ${textColor} group-hover:text-blue-500 transition-colors duration-300`}>
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-blue-500">Fep</span>
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-teal-400">sec</span>
          {/* <span className="text-sm font-medium ml-1 text-gray-500 hidden md:inline-block">Limited</span> */}
        </div>
      )}
    </div>
  );
};

export default Logo;
